<template>
  <div>
    <div class="content">
      <div class="img-wrap">
        <img src="../../assets/pay-success.png" class="status-img" />
      </div>
      <div class="status-text">提交成功，出单中...</div>
      <div class="status-text-1">预计24小时内客服联系您出单，请保持通话畅通，如有问题请致电400-000-7535</div>
    </div>
    <div class="bottomBtn">
      <span class="goHome" @click.stop="goHome"><img src="../../assets/back.png" alt="" />返回首页</span>
    </div>
  </div>
</template>

<script>
import { myTrack } from "../../common/track";
import { getUrlParams } from "../../common/utils";
export default {
  name: "offLineSuccess",
  data() {
    return {
      mainFirm: sessionStorage.getItem("mainFirm") || "",
    };
  },
  methods: {
    goHome() {
      try {
        myTrack("insurance_youjiabao_large_policy_order_success_page", {
          click_back_to_home: "点击返回首页",
        });
      } catch (error) {
        window.console.log(error);
      }
      let homeUrl = sessionStorage.getItem("offLineSuccessToHome");
      sessionStorage.removeItem("offLineSuccessToHome");
      window.location.href = homeUrl;
    },
  },
  mounted() {
    myTrack("insurance_youjiabao_large_policy_order_success_page", {
      youjiabao_large_success_page_visit: "页面访问",
      product_channel: getUrlParams().orderSource ? getUrlParams().orderSource : "",
    });
  },
};
</script>

<style scoped lang="scss">
@function toVw($px) {
  @return $px / 7.5 * 1vw;
}

.content {
  background: #ffffff;
  margin-bottom: toVw(80);

  .img-wrap {
    width: 100%;
    text-align: center;
    vertical-align: middle;

    .status-img {
      width: 21.33vw;
      margin-top: 10.67vw;
      margin-bottom: 6.67vw;
    }
  }

  .status-text {
    height: 8.67vw;
    line-height: 8.67vw;
    font-size: 4.8vw;
    text-align: center;
    color: #3385ff;
  }

  .status-text-1 {
    height: 19.33vw;
    line-height: 7.33vw;
    text-align: center;
    color: #999999;
  }
}

.bottomBtn {
  display: inline-flex;
  justify-content: center;
  align-items: center;

  a {
    text-decoration: none;
  }

  span {
    display: inline-flex;
    align-items: center;
    width: 30.4vw;
    height: 9.07vw;
    border-radius: 1.33vw;
    font-size: 3.73vw;
    margin-bottom: 4vw;

    img {
      width: 5.07vw;
      height: 5.07vw;
      margin-right: 1.33vw;
    }
  }

  .goHome {
    display: flex;
    justify-content: center;
    align-items: center;
    background: #3385ff;
    color: #ffffff;
  }
}
</style>
